import React from "react";

export const LoadingSpinner = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] w-full p-6">
      <div className="relative flex items-center justify-center">
        {/* Outer Ring */}
        <div className="w-16 h-16 rounded-full border-4 border-slate-100 dark:border-slate-800 animate-pulse"></div>
        {/* Inner Spinning Ring */}
        <div className="absolute w-16 h-16 rounded-full border-4 border-transparent border-t-blue-600 dark:border-t-blue-400 animate-spin"></div>
        {/* Center dot */}
        <div className="absolute w-3 h-3 rounded-full bg-blue-500 animate-ping"></div>
      </div>
      <p className="mt-4 text-sm font-medium text-slate-500 dark:text-slate-400 animate-pulse">
        Loading page...
      </p>
    </div>
  );
};

export default LoadingSpinner;
